export default __webpack_public_path__ + "static/media/pouf5.79f1714c.JPG";